import {
    buildConfigSlice,
    useConfigSlice,
    WidgetConfigSliceActionPayloadType,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import {
    initialVolumeCapsuleConfigState,
    VolumeCapsuleConfigState,
} from 'widgets/liquiditySummary/volumeCapsule/state/config/VolumeCapsuleConfigState';
import { selectVolumeCapsuleState } from 'widgets/liquiditySummary/volumeCapsule/state/selectors';

export const buildVolumeCapsuleConfigSlice = () =>
    buildConfigSlice<VolumeCapsuleConfigState>(
        WidgetType.VOLUME_CAPSULE,
        selectVolumeCapsuleState,
        initialVolumeCapsuleConfigState
    );

export const useVolumeCapsuleConfigSlice = () =>
    useConfigSlice(buildVolumeCapsuleConfigSlice());

export type VolumeCapsuleConfigPayloadType =
    WidgetConfigSliceActionPayloadType<VolumeCapsuleConfigState>;
